import scatter from 'daisy-chart/src/layouts/scatter';
import data from './data/weather.json';

scatter().data(data)
  .name('scatter')
  .container('#daisy-example')
  .dimension('날짜')
  .measures(['최고기온(℃)', '최저기온(℃)'])
  .axis('x').axis('y')
  .facet('vertical')
  .render();
    


// WEBPACK FOOTER //
// ./js/examples/facetScatter.js